/**
 * How To Use Section - Interactive Script
 * Handles search functionality
 */

(function() {
  'use strict';

  // State
  let isSearchActive = false;
  let allVideoCards = [];
  let allCollections = [];

  // DOM Elements
  const searchInput = document.getElementById('HowToUseSearchInput');
  const searchContainer = document.getElementById('HowToUseSearchContainer');
  const searchClear = document.getElementById('HowToUseSearchClear');
  const searchClose = document.getElementById('HowToUseSearchClose');
  const noResults = document.getElementById('HowToUseNoResults');
  const content = document.getElementById('HowToUseContent');

  /**
   * Initialize the section
   */
  function init() {
    if (!searchInput) return;

    // Cache all video cards and collections
    allVideoCards = Array.from(document.querySelectorAll('.video-product-card-wrapper'));
    allCollections = Array.from(document.querySelectorAll('.how-to-use-section__collection[data-collection]'));

    // Event listeners
    searchInput.addEventListener('input', handleSearchInput);
    searchInput.addEventListener('focus', handleSearchFocus);
    searchClear.addEventListener('click', clearSearch);
    searchClose.addEventListener('click', closeSearch);
  }

  /**
   * Handle search input
   */
  function handleSearchInput(e) {
    const query = e.target.value.trim().toLowerCase();
    const hasInput = query.length > 0;

    if (hasInput) {
      isSearchActive = true;
      // Add has-input class and show CLEAR + Close buttons
      if (searchContainer) {
        searchContainer.classList.add('has-input');
      }
      if (searchClear) {
        searchClear.style.display = 'flex';
      }
      if (searchClose) {
        searchClose.style.display = 'flex';
      }

      // Add searching class to section
      const section = document.querySelector('.how-to-use-section');
      if (section) {
        section.classList.add('is-searching');
      }

      // Filter video cards
      let visibleCount = 0;
      allVideoCards.forEach(card => {
        const title = card.getAttribute('aria-label') || '';
        const matches = title.toLowerCase().includes(query);

        if (matches) {
          card.classList.add('is-visible');
          visibleCount++;
        } else {
          card.classList.remove('is-visible');
        }
      });

      // Show/hide no results message and content
      if (noResults) {
        noResults.style.display = visibleCount === 0 ? 'block' : 'none';
      }

      if (content) {
        content.style.display = visibleCount === 0 ? 'none' : 'block';
      }
    } else {
      resetSearch();
    }
  }

  /**
   * Handle search focus
   */
  function handleSearchFocus() {
    if (searchInput.value.trim().length > 0) {
      isSearchActive = true;
      if (searchClear) {
        searchClear.style.display = 'flex';
      }
      if (searchClose) {
        searchClose.style.display = 'flex';
      }
    }
  }

  /**
   * Clear search
   */
  function clearSearch() {
    searchInput.value = '';
    resetSearch();
    searchInput.focus();
  }

  /**
   * Close search
   */
  function closeSearch() {
    searchInput.value = '';
    resetSearch();
    searchInput.blur();
  }

  /**
   * Reset search state
   */
  function resetSearch() {
    isSearchActive = false;
    // Remove has-input class and hide CLEAR + Close buttons
    if (searchContainer) {
      searchContainer.classList.remove('has-input');
    }
    if (searchClear) {
      searchClear.style.display = 'none';
    }
    if (searchClose) {
      searchClose.style.display = 'none';
    }

    // Remove searching class from section
    const section = document.querySelector('.how-to-use-section');
    if (section) {
      section.classList.remove('is-searching');
    }

    // Show all video cards
    allVideoCards.forEach(card => {
      card.classList.remove('is-visible');
    });

    // Show no results message
    if (noResults) {
      noResults.style.display = 'none';
    }

    // Show content
    if (content) {
      content.style.display = 'block';
    }

    // Show all collections
    allCollections.forEach(collection => {
      collection.style.display = 'block';
    });
  }

  /**
   * Initialize on DOM ready
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
